//This will be the dropdown item you see on the schedule page.  You can choose from
//either a league or a team to view a desired schedule
import React, { useState, useEffect } from 'react'
import Card from './Card'
import { useNavigate } from 'react-router-dom'
//import LeagueDatabaseTable from '../LeagueDatabaseTable'

const SearchByLeagueOrVenue = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeagues, setLoadedLeagues] = useState()
	const [loadedTeams, setLoadedTeams] = useState()
	const [loadedVenues, setLoadedVenues] = useState()
	const [loadedDivisions, setLoadedDivisions] = useState()
	const [error, setError] = useState()

	let selectedLeague, selectedTeam, selectedVenue, selectedDivision

	console.log('inside SearchByLeagueOrVenue')

	//Call backend to get all the current leagues for our dropdown
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedLeagues(responseData.currentLeagues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedLeagues])

	let leagueArray

	if (loadedLeagues && !isLoading) {
		leagueArray = []
		loadedLeagues.forEach((league) => {
			const leagueDisplay =
				league.leagueName +
				/* (league.divisionName && ' - ' + league.divisionName + ' DIVISION') +
				' - ' +
				league.session + */
				' - ' +
				league.year
			leagueArray.push(leagueDisplay)
		})
	}
	//
	leagueArray && console.log('leagueArray length: ' + leagueArray.length)
	//
	//
	//
	//
	//Call backend to get all the current TEAMS for our dropdown
	useEffect(() => {
		const sendRequest2 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/league/allCurrentTeams'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedTeams(responseData.currentTeamsArray)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest2()
	}, [setLoadedTeams])

	let teamArray

	if (loadedTeams && !isLoading) {
		teamArray = []
		loadedTeams.forEach((team) => {
			teamArray.push(team)
		})
		teamArray.sort((a, b) => a.divisionName.localeCompare(b.divisionName))
	}
	//
	//
	//
	//Call backend to get all the current VENUES for our dropdown
	useEffect(() => {
		const sendRequest3 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/venues'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error('error message: ' + responseData.message)
				}

				//console.log('responseData: ' + JSON.stringify(responseData))

				setLoadedVenues(responseData.allVenues)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest3()
	}, [setLoadedVenues])

	let venueArray

	if (loadedVenues && !isLoading) {
		venueArray = []
		loadedVenues.forEach((venue) => {
			//const teamDisplay = team
			venueArray.push(venue.venueName)
		})
	}
	//
	//
	//
	//Call backend to get all the current DIVISIONS for our dropdown
	useEffect(() => {
		const sendRequest4 = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/divisions'
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error('error message: ' + responseData.message)
				}

				setLoadedDivisions(responseData.allDivisions)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest4()
	}, [setLoadedDivisions])

	let divisionsArray

	if (loadedDivisions && !isLoading) {
		divisionsArray = []
		loadedDivisions.forEach((division) => {
			//const teamDisplay = team
			divisionsArray.push(division)
		})
	}

	//console.log('loadedDivisions: ' + JSON.stringify(loadedDivisions))

	let navigate = useNavigate()
	//For handling a search by team request:
	const handleChange1 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedTeam = teamArray[selectedValue]
		//console.log('selectedTeam: ' + JSON.stringify(selectedTeam))
		const teamId = selectedTeam._id
		navigate(`/league/teamSchedule/${teamId}`)
	}

	//For handling a search by league request:
	const handleChange = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedLeague = loadedLeagues[selectedValue]
		const leagueId = selectedLeague._id
		navigate(`/league/schedule/${leagueId}`)
	}

	//For handling a search by VENUE request
	const handleChange3 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		selectedVenue = loadedVenues[selectedValue]
		const venueId = selectedVenue._id
		navigate(`/league/${venueId}/schedule`) //< - - - should go to VenueSchedule
	}

	//For handling a search by Division request
	const handleChange4 = (e) => {
		e.preventDefault()
		const selectedValue = e.target.value
		console.log('selectedValue: ' + selectedValue)
		selectedDivision = divisionsArray[selectedValue]
		console.log('selectedDivision: ' + selectedDivision)
		const divisionId = selectedDivision._id
		navigate(`/league/division/${divisionId}/schedule`) //< - - - should go to DivisionSchedule
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				{/* <Card> */}
				<div className='searchbyleagueorvenue'>
					<div className='row'>
						{leagueArray && leagueArray.length < 2 && (
							<div className='LTVinstructions'>
								View by Team, Division, or Venue:{' '}
							</div>
						)}
						{leagueArray && leagueArray.length > 1 && (
							<div className='LTVinstructions'>View by Team or Venue: </div>
						)}
					</div>
					{!isLoading && loadedTeams && (
						<div className='row'>
							<div className='col'></div>
							<div className='col-sm'>
								{/* <form className='form-control-lg'> */}
								<form className='dropdownForm' style={{ textAlign: 'center' }}>
									<select
										className='scheduleselector'
										// className='my-1 mr-sm-2 scheduleselector'
										onChange={handleChange1}
									>
										<option defaultValue>Team....</option>
										{teamArray.map((team, i) => (
											<option value={i} key={i}>
												{/* {team.toUpperCase()} */}
												{team.divisionName + ' >>> ' + team.teamName}
											</option>
										))}
									</select>
								</form>
							</div>
							<div className='col'></div>
						</div>
					)}
					{!isLoading &&
						loadedDivisions &&
						leagueArray &&
						leagueArray.length < 2 && (
							<div className='row'>
								<div className='col'></div>
								<div className='col-sm'>
									{/* <form className='form-control-lg'> */}
									<form
										className='dropdownForm'
										style={{ textAlign: 'center' }}
									>
										<select
											className='scheduleselector'
											// className='my-1 mr-sm-2 scheduleselector'
											onChange={handleChange4}
										>
											<option defaultValue>Division....</option>
											{divisionsArray.map((division, i) => (
												<option value={i} key={i}>
													{/* {team.toUpperCase()} */}
													{division.divisionName}
												</option>
											))}
										</select>
									</form>
								</div>
								<div className='col'></div>
							</div>
						)}
					{/* {!isLoading && loadedLeagues && (
						<div className='row'>
							<div className='col'></div>
							<div className='col-sm'>
								<form className='dropdownForm' style={{ textAlign: 'center' }}>
									<select className='scheduleselector' onChange={handleChange}>
										<option defaultValue>Tournament....</option>
										{leagueArray.map((league, i) => (
											<option value={i} key={i}>
												{league.toUpperCase()}
											</option>
										))}
									</select>
								</form>
							</div>
							<div className='col'></div>
						</div>
					)} */}
				</div>
				{!isLoading && loadedVenues && (
					<div className='row'>
						<div className='col'></div>
						<div className='col-sm'>
							<form className='dropdownForm' style={{ textAlign: 'center' }}>
								{/* <form className='form-control-lg'> */}
								{/* matt:  wtf is custom-select?   was a className here but i deleted*/}
								<select className='scheduleselector' onChange={handleChange3}>
									<option defaultValue>Venue....</option>
									{venueArray.map((venue, i) => (
										<option value={i} key={i}>
											{venue}
										</option>
									))}
								</select>
							</form>
						</div>
						<div className='col'></div>
					</div> /* < - - end of row */
				)}
			</React.Fragment>
		</div>
	)
}

export default SearchByLeagueOrVenue
